import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useActiveOrganisation from '../collaboration/useActiveOrganisation';
import { alpha } from '@mui/material/styles';
import theme from '../resources/NodeTheme';

interface PageHeaderProps {
  title: string;
  showCompanyName?: boolean;
  sx?: any;
}

const PageHeader = ({ title, showCompanyName = true, sx }: PageHeaderProps) => {
  const { t } = useTranslation();
  const [activeOrganisation] = useActiveOrganisation();

  return (
    <Box sx={{ 
      marginBottom: { xs: 2, sm: 3 },
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      flexWrap: 'wrap',
      ...sx
    }}>
      <Typography 
        variant="h5" 
        component="h1" 
        sx={{
          fontFamily: 'Cabinet Grotesk, sans-serif',
          fontWeight: 700,
          color: theme.palette.primary.main,
        }}
      >
        {title}
      </Typography>
      {showCompanyName && activeOrganisation?.organizationName && (
        <Typography 
          variant="body1" 
          sx={{
            color: alpha(theme.palette.primary.main, 0.7),
            fontFamily: 'Inter, sans-serif',
            fontWeight: 400,
          }}
        >
          {activeOrganisation.organizationName}
        </Typography>
      )}
    </Box>
  );
};

export default PageHeader; 